import {
  type DropdownOption,
  ChakraBox,
  ChakraFlex,
  Divider,
  InputGroupV2,
  SwitchV2,
  Text,
  UniversalSelect,
} from '@equip.health/ui';
import { appointmentInputWidth } from '~/components/common/calendar/SchedulerV2';

interface AvailabilitySettingsProps {
  topLevelId: string;
  appointmentTypeOptions?: DropdownOption[];
  activeAppointmentType?: DropdownOption;
  recurrenceOption: DropdownOption;
  recurrenceOptions?: DropdownOption[];
  ignoreAvailabilitySettings: boolean;
  disableIgnoreAvailabilitySettings: boolean;
  onAppointmentTypeChange?: (option: DropdownOption) => void;
  onFrequencyChange?: (option: DropdownOption) => void;
  onToggleIgnoreAvailability: () => void;
  showAppointmentType?: boolean;
  showRecurrence?: boolean;
  shouldDisableRecurrence?: boolean;
  shouldEditAllAppointments?: boolean;
}

const AvailabilitySettings = ({
  topLevelId,
  appointmentTypeOptions,
  activeAppointmentType,
  recurrenceOption,
  recurrenceOptions = [],
  ignoreAvailabilitySettings,
  disableIgnoreAvailabilitySettings,
  onAppointmentTypeChange,
  onFrequencyChange,
  onToggleIgnoreAvailability,
  showAppointmentType = false,
  showRecurrence = false,
  shouldDisableRecurrence,
  shouldEditAllAppointments,
}: AvailabilitySettingsProps) => {
  return (
    <>
      <ChakraFlex
        alignItems="center"
        gap="36px"
        height="60px"
        marginBottom="24px"
        width="100%"
      >
        {showAppointmentType && appointmentTypeOptions && (
          <ChakraBox width={appointmentInputWidth}>
            <InputGroupV2
              id={`${topLevelId}__input-appointment-type`}
              label="Appointment type"
            >
              <UniversalSelect
                id={`${topLevelId}__appointment-type-options`}
                isClearable={false}
                isDisabled={shouldEditAllAppointments}
                isSingleSelect
                modalId={topLevelId}
                onChange={onAppointmentTypeChange}
                options={appointmentTypeOptions}
                placeholder="Select an appointment type"
                value={activeAppointmentType}
              />
            </InputGroupV2>
          </ChakraBox>
        )}

        {showRecurrence && (
          <ChakraBox width={appointmentInputWidth}>
            <InputGroupV2
              id={`${topLevelId}__input-recurrence-type`}
              label="Recurrence"
            >
              <UniversalSelect
                id={`${topLevelId}__recurrence-type-options-2`}
                isClearable={false}
                isDisabled={
                  shouldDisableRecurrence || shouldEditAllAppointments
                }
                isSingleSelect
                modalId={topLevelId}
                onChange={onFrequencyChange}
                options={recurrenceOptions}
                placeholder="select frequency"
                value={recurrenceOption}
              />
            </InputGroupV2>
          </ChakraBox>
        )}

        <ChakraBox width={appointmentInputWidth}>
          <ChakraFlex alignItems="center" gap="10px">
            <SwitchV2
              id={`${topLevelId}__scheduler__ignore-availability-switch`}
              isChecked={ignoreAvailabilitySettings}
              isDisabled={disableIgnoreAvailabilitySettings}
              onChange={onToggleIgnoreAvailability}
              size="lg"
            />
            <Text>Ignore availability settings</Text>
          </ChakraFlex>
        </ChakraBox>
      </ChakraFlex>

      <Divider
        id={`${topLevelId}__appointment-type-divider`}
        marginBottom="24px"
      />
    </>
  );
};

export default AvailabilitySettings;
